<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useDisciplineTasksStore } from '../model/tasks/store'
import { abortDisciplineTasksApi, useDisciplineTasksApi } from '../api/tasks.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import TableDisciplineTasks from './TableDisciplineTasks.vue'
import ModalDisciplineTaskCreate from './modals/ModalDisciplineTaskCreate.vue'
import ModalDisciplineTaskEdit from './modals/ModalDisciplineTaskEdit.vue'
import ModalDisciplineTaskPostpone from './modals/ModalDisciplineTaskPostpone.vue'
import ModalDisciplineTaskDeclined from './modals/ModalDisciplineTaskDeclined.vue'
import ModalDisciplineTaskCancel from './modals/ModalDisciplineTaskCancel.vue'
import ModalDisciplineTaskDelete from './modals/ModalDisciplineTaskDelete.vue'

defineOptions({
  name: 'DisciplineTasksPage',
})

const route = useRoute()
const store = useDisciplineTasksStore()

/** The first list read shares the page loader with the discipline, so the tab appears with its rows in place; a
 *  Search or a page change keeps the rows and only locks the controls. */
const refIsFirstLoad = computed<boolean>(() => store.isLoading && store.getMeta === null)

const fetchTasks = (): void => {
  void useDisciplineTasksApi({ disciplineId: route.params.id as string })
}

onMounted(fetchTasks)

// Filters and pagination navigate by query; the middleware has already written them to the store.
watch(() => route.query, () => {
  if (route.name === 'disciplines-id-tasks') fetchTasks()
})

// Due dates arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
useOnTimezoneChange(fetchTasks)

onBeforeUnmount(() => {
  abortDisciplineTasksApi()
  store.closeModal()
  store.resetList()
})
</script>

<template>
  <DisciplinePageLoader :loading="refIsFirstLoad" />
  <TableDisciplineTasks />
  <ModalDisciplineTaskCreate />
  <ModalDisciplineTaskEdit />
  <ModalDisciplineTaskPostpone />
  <ModalDisciplineTaskDeclined />
  <ModalDisciplineTaskCancel />
  <ModalDisciplineTaskDelete />
</template>
